/**
 * Buscador por texto (BUS-01), sugerencias (BUS-02) y por foto (BUS-03).
 */
import type {
  FiltrosBusqueda,
  ResultadoBusqueda,
  SugerenciasBusqueda,
} from '@elcarpintero/compartido';

import { parametrosDe } from '../utilidades/filtros-busqueda';
import { pedir } from './cliente-api';

export function buscar(
  termino: string,
  opciones: { pagina?: number; filtros?: FiltrosBusqueda; senal?: AbortSignal } = {},
): Promise<ResultadoBusqueda> {
  return pedir<ResultadoBusqueda>('/busqueda', {
    parametros: { termino, pagina: opciones.pagina, ...parametrosDe(opciones.filtros ?? {}) },
    ...(opciones.senal ? { senal: opciones.senal } : {}),
  });
}

/**
 * Sugerencias del autocompletado (BUS-02).
 *
 * Se llama mientras el comprador escribe, asi que SIEMPRE con senal de aborto:
 * la respuesta de "bisa" no puede llegar despues de la de "bisagra" y pisarla.
 */
export function sugerencias(termino: string, senal: AbortSignal): Promise<SugerenciasBusqueda> {
  return pedir<SugerenciasBusqueda>('/busqueda/sugerencias', { parametros: { termino }, senal });
}

/**
 * Busqueda por foto (BUS-03, BUS-05).
 *
 * Manda los bytes de la foto ya reducida y nada mas: sin nombre de archivo, sin
 * formulario y sin metadatos. El servidor la compara y la descarta; no queda
 * guardada en ninguno de los dos lados.
 */
export function buscarPorFoto(
  foto: Blob,
  opciones: { senal?: AbortSignal } = {},
): Promise<ResultadoBusqueda> {
  return pedir<ResultadoBusqueda>('/busqueda/foto', {
    metodo: 'POST',
    cuerpoBinario: foto,
    ...(opciones.senal ? { senal: opciones.senal } : {}),
  });
}
